import React from 'react';

const About = () => {
  const achievements = [
    'First prototypes deployed with real customers',
    'World-first passive flow sensing technology',
    'Cloud-connected data analytics platform',
    'Advanced data insights and recommendations',
    'Patent filed February 2025 for non-invasive flow sensor technology'
  ];

  return (
    <section id="about" className="section-padding">
      <div className="container-max px-4">
        <div className="w-full max-w-4xl mx-auto text-center mb-20">
          <p className="text-xs font-bold tracking-widest text-rebel-coral uppercase mb-4 font-sans" style={{maxWidth: 'none'}}>
            ABOUT US
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold mb-8 text-rebel-dark leading-tight">
            About Rebel
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed w-full" style={{maxWidth: 'none'}}>
            Making heating smarter and more sustainable. We're passionate about helping the UK transition to clean heat.
          </p>
        </div>

        {/* Technology & Innovation */}
        <div className="mb-20">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl sm:text-4xl font-bold text-rebel-dark mb-12 text-center">
              Achievements
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {achievements.map((achievement, index) => (
                <div key={index} className="game-card p-6 flex items-start space-x-4">
                  <svg className="w-6 h-6 text-rebel-green flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                  </svg>
                  <span className="text-gray-600" role="listitem">{achievement}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Founder Section */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl sm:text-4xl font-bold text-rebel-dark mb-6">Team</h3>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="game-card p-12">
              <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-6 lg:space-y-0 lg:space-x-8">
                {/* Profile Image Placeholder */}
                <div className="flex-shrink-0">
                  <div className="w-32 h-32 bg-gradient-to-br from-rebel-coral to-rebel-orange rounded-2xl flex items-center justify-center shadow-lg">
                    <span className="text-4xl font-bold text-white">JT</span>
                  </div>
                </div>

                {/* Bio Content */}
                <div className="flex-1 text-center lg:text-left">
                  <h4 className="text-2xl font-bold text-rebel-dark mb-2">James Twallin</h4>
                  <p className="text-rebel-coral font-semibold mb-6">Founder & CTO</p>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    With over 12 years in energy, working on geophysical seismic data processing, wind farm yields,
                    battery algorithms, and optimisation for tepeo's ZEB. With three patents covering heating systems,
                    I focus on data and machine learning for smarter energy solutions.
                  </p>

                  {/* Skills */}
                  <div>
                    <h5 className="text-lg font-bold text-rebel-dark mb-4">Expertise</h5>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                      {[
                        'Remote Sensing',
                        'Machine Learning',
                        'Non-linear Optimisation',
                        'Forecasting',
                        'Full Stack Development',
                        'Data Engineering'
                      ].map((skill, index) => (
                        <span key={index} className="bg-gray-100 border border-gray-200 px-4 py-2 text-sm text-gray-700 rounded-lg">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      

        {/* Vision Statement */}
        <div className="text-center">
          <div className="bg-gradient-to-br from-rebel-teal to-rebel-green rounded-3xl p-12 max-w-4xl mx-auto">
            <h3 className="text-3xl sm:text-4xl font-bold text-white mb-6">Our Mission</h3>
            <p className="text-lg sm:text-xl text-white/90 leading-relaxed mb-6 italic">
              "You can't solve a problem without understanding it first. Our technology maps the problem,
              so we can take away the guesswork and make clean heat adoption straightforward, affordable and data-driven."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;